import i18n from 'i18next';

import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locale/en.json';
import es from './locale/es.json';
import fr from './locale/fr.json';
import it from './locale/it.json';

export const resources = {
    en: {
        translation: en
    },
    es: {
        translation: es
    },
    fr: {
        translation: fr
    },
    it: {
        translation: it
    }
} as const;


//localStorage.setItem('i18nextLng', 'en');
const language = navigator.language;


if (language !== 'es' && language !== 'fr' && language !== 'it') {
    if (!localStorage.getItem('i18nextLng')) {
        localStorage.setItem('i18nextLng', 'en')
    }
} else {
    if (!localStorage.getItem('i18nextLng')) {
        localStorage.setItem('i18nextLng', language)
    }
}; 
let lng = localStorage.getItem('i18nextLng');


(i18n as any).use(initReactI18next).init({
    resources,
    lng: lng,
    fallbackLng: lng,
    debug: false,
    interpolation: {
        escapeValue: false // not needed for react as it escapes by default
    }
});

